module.exports = __webpack_public_path__ + "static/jenga-b24167b0afd1e9da16fca830d12b156d.jpg";